import React, { Component } from 'react'

import get from 'lodash/get'
import head from 'lodash/head'
import uniqBy from 'lodash/uniqBy'
import { Tooltip } from 'react-tippy'

import * as click from '../../../../../assets/icons/click.svg'
import withTour from '../../../../../components/hocs/withTour'
import Insight from '../../../../../components/renderPropComponents/Insight'
import InfoButton from '../../../../../components/ui/buttons/InfoButton'
import sampleCategoryData from '../static/CategoryData'

import AverageSalaryCardData from './AverageSalaryCardData'
import CompanyCard from './components/CompanyCard'
import RankingBars from './components/RankingBars'
import SalaryDataResultCard from './SalaryDataResultCard'
import SalaryZoomChart from './SalaryZoomChart'
import ViewAverageSalary from './ViewAverageSalary'

class CareerResult extends Component {
  constructor() {
    super()

    this.state = {
      activeCommonJob: 0,
      activeHighPayJob: 0,
      activeCard: 1,
      chartLineName: 'mean_salary',
    }

    this.getCategoryData = categoryName => {
      const categoryObj = {}
      sampleCategoryData.forEach(category => {
        if (category.category === categoryName) {
          categoryObj.category = categoryName
          categoryObj.employmentGrowth = category.employmentGrowth
          categoryObj.jobs2016 = category.jobs2016
        }
      })
      return categoryObj
    }
  }

  componentWillMount() {
    this.props.onChangeResultsPage('educationPage2')
  }

  render() {
    const {
      commonJobSalaryData,
      predictedSalary,
      salaryData,
      isMobile,
      resultHeaders,
      searchType,
      searchClassification,
      salaryDistribution,
      insight,
      topCompanies,
      yearsToPosition,
      addCompanyToSearch,
      topJobsSalaryData,
    } = this.props

    const { activeCard, chartLineName } = this.state

    const categoryData = this.getCategoryData(searchClassification)
    // Common jobs are too low for some searches, so add top jobs to that if below 5
    // TODO: handle relevance for top jobs
    const finalCommonJobsSalaryData =
      commonJobSalaryData &&
      !!commonJobSalaryData.length &&
      commonJobSalaryData.length > 5
        ? commonJobSalaryData
        : uniqBy([...commonJobSalaryData, ...topJobsSalaryData], o => o.name)

    return (
      <div>
        <div className="card shadow">
          <div>
            <div style={{ borderBottom: '1px solid #e7ecf1' }}>
              <div className="row" id="eyeCards">
                <div className="col-md-4 pr-0" id="averageSalary">
                  <Insight content={insight} willShow={!!insight}>
                    <ViewAverageSalary
                      isMobile={isMobile}
                      yearsToPosition={yearsToPosition}
                      predictedSalary={predictedSalary}
                      description="Annual Salary"
                      isActive={activeCard === 0}
                      onClick={() =>
                        this.setState({
                          activeCard: 0,
                          salaryChartData: salaryData,
                          chartLineName: 'mean_salary',
                        })
                      }
                    />
                  </Insight>
                </div>
                {!isMobile && (
                  <div
                    className="col-md-4"
                    style={{ borderLeft: '1px solid #e7ecf1' }}
                  >
                    <SalaryDataResultCard
                      title="Common Jobs"
                      name={get(head(finalCommonJobsSalaryData), 'name')}
                      salary={get(head(finalCommonJobsSalaryData), 'salaryVal')}
                      isActive={activeCard === 1}
                      onClick={() =>
                        this.setState({
                          activeCard: 1,
                        })
                      }
                    />
                  </div>
                )}
                {!isMobile && (
                  <div
                    className="col-md-4"
                    style={{
                      borderLeft: '1px solid #e7ecf1',
                      paddingRight: 30,
                    }}
                  >
                    <SalaryDataResultCard
                      style={{ border: '1px solid red' }}
                      title="Top Companies"
                      name={get(head(topCompanies), 'name')}
                      companyId={get(head(topCompanies), 'companyId')}
                      isActive={activeCard === 2}
                      onClick={() =>
                        this.setState({
                          activeCard: 2,
                        })
                      }
                      hasIcon={true}
                    />
                  </div>
                )}
              </div>
            </div>
            <div style={{ minHeight: 450 }} id="salaryChart">
              {activeCard > -1 && (
                <h6 className="m-3 color-blue" style={{ paddingLeft: 20 }}>
                  {resultHeaders[activeCard].header}
                  &nbsp;&nbsp;
                  {!!resultHeaders[activeCard].tipContent && (
                    <InfoButton
                      content={resultHeaders[activeCard].tipContent}
                      styles={{ color: '#808080' }}
                    />
                  )}
                </h6>
              )}
              <div className="row m-0">
                {/* // Nothing clicked */}
                {activeCard === -1 && (
                  <div
                    className="col-12 text-center"
                    style={{
                      backgroundColor: 'white',
                      paddingTop: 140,
                      color: 'gray',
                    }}
                  >
                    <i className="fal fa-hand-point-up fa-2x" /> <br />
                    Click&nbsp;
                    <img
                      src={click}
                      style={{ width: 25 }}
                      alt="mouse pointer"
                    />
                    <br />
                    above for details
                  </div>
                )}
                {/* 1st - career - Distribution & facts */}
                {activeCard === 0 && searchType === 'career' && (
                  <div className="col-12">
                    <AverageSalaryCardData
                      predictedSalary={predictedSalary}
                      categoryData={categoryData}
                      salaryDistribution={salaryDistribution}
                      yearsToPosition={yearsToPosition}
                    />
                  </div>
                )}
                {/* 1st - education - TBD*/}
                {activeCard === 0 && searchType === 'education' && (
                  <div className="col-12">
                    <SalaryZoomChart
                      chartData={salaryData}
                      chartLineName={chartLineName}
                      height={400}
                    />
                  </div>
                )}
                {/* 2nd - Common Jobs */}
                {activeCard === 1 && (
                  <div className="col-12">
                    <div className="row mb-3">
                      <div className="offset-md-4 col text-center">
                        <Tooltip
                          position="top"
                          title="The most frequently occurring previous jobs in this group."
                        >
                          <i
                            className="fal fa-fire mr-1"
                            style={{ color: '#FF9551' }}
                          />
                          Volume
                        </Tooltip>
                      </div>
                      <div className="col text-center">
                        <Tooltip
                          position="top"
                          title="The relative significance, compared against the general population."
                        >
                          <i
                            className="fal fa-chart-network mr-1"
                            style={{ color: '#99c4ee' }}
                          />
                          Relevance
                        </Tooltip>
                      </div>
                      <div className="col text-center">
                        <Tooltip
                          position="top"
                          title="The job titles most likely to align with higher salary outcomes."
                        >
                          <i
                            className="fa fa-dollar-sign mr-1"
                            style={{ color: '#68CEB7' }}
                          />
                          Salary
                        </Tooltip>
                      </div>
                    </div>
                    {finalCommonJobsSalaryData.map((job, index) => (
                      <RankingBars
                        key={`${get(job, 'name')}-${index}`}
                        name={get(job, 'name')}
                        popularity={get(job, 'count')}
                        relevance={get(job, 'relevance')}
                        salary={get(job, 'salary')}
                        type="career"
                        isMobile={false}
                      />
                    ))}
                  </div>
                )}
                {/* 3rd - Top Companies*/}
                {activeCard === 2 && (
                  <div className="row m-0">
                    {topCompanies &&
                      !!topCompanies.length &&
                      topCompanies.map(company => (
                        <div key={company.name} className="col-md-6">
                          <div className="company-card">
                            <div className="card-body">
                              <CompanyCard
                                key={get(company, 'name')}
                                name={get(company, 'name')}
                                companyId={get(company, 'companyId')}
                                skills={get(company, 'topSkills')}
                                avgSalary={get(company, 'avgSalary')}
                                isMobile={false}
                                addCompanyToSearch={addCompanyToSearch}
                                companySearchEnabled={
                                  searchType === 'career' ? true : false
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const educationPage2 = [
  {
    selector: '#eyeCards',
    content: 'Click on any card that interests you to learn more',
  },
  {
    selector: '#salaryChart',
    content: 'Details about your chosen card will appear here',
  },
  {
    selector: '#search360Tabs',
    content: "Click other tabs here when you're ready for more",
  },
]

export default withTour('educationPage2', educationPage2)(CareerResult)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/CareerResult.js